import React, { useEffect, useState } from 'react'
import Axios from 'axios'
import './App.css'
import Box from '@mui/material/Box'
import K from '../services/k'
import Services from '../services/Services'
import Filter from './filter/filter'
import RestaurantComponent from './filter/RestaurantComponent'
import RestaurantLoader from './loader/RestaurantLoader'
import CategoryLoader from './loader/CategoryLoader'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import { Hidden } from '@material-ui/core'
import Fab from '@mui/material/Fab'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import RestaurantMap from './map/RestaurantMap'
import ProductCard from './product/ProductCard'

function Restaurants(props) {
  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme != props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  const [restaurantcategory, setrestaurantcategory] = useState(0)

  const [distanceFilter, setDistanceFilter] = useState({
    min: 0,
    max: 15,
  })

  const [sort, setSortFilter] = useState('All')

  const [diatery, setDiatery] = useState('')

  const [isLoading, setisLoading] = useState(false)

  window.$('.modal').modal('hide')
  const service = new Services()
  const token = localStorage.getItem(['__react_session__'])
  const key = 'updatable'

  const jsontoken = JSON.parse(token)
  const [statecoordinates, setstatecoordinates] = useState({})
  const [address, setAddress] = useState('')

  const openRestaurant = (restaurantId) => {
    localStorage.setItem('restaurantId', restaurantId)
    window.location.href = '/single-restaurant'
  }

  useEffect(() => {
    let categoryParams = 0
    try {
      categoryParams = isNaN(parseInt(localStorage.getItem('maincategory')))
        ? 0
        : parseInt(localStorage.getItem('maincategory'))
    } catch (error) {
      console.log(error)
    }
    setrestaurantcategory(categoryParams)

    if (jsontoken !== '' && jsontoken !== null) {
      setstatecoordinates(jsontoken.coordinates)
      setAddress(jsontoken.address)
    } else {
      setstatecoordinates(undefined)
    }
  }, [])

  //add restaurants response to state
  const [allRestaurants, setAllRestaurants] = useState([])
  const [mainCategories, setMaincategories] = useState([])
  const [maincategoriesLoading, setmaincategoriesLoading] = useState([])

  const [restaurantFilterArray, setRestaurantFilterArray] = useState([])

  const [onlineRestaurantFilterArray, setOnlineRestaurantFilterArray] =
    useState([])
  const [nearMe5kmRestaurantFilterArray, setNearMe5kmRestaurantFilterArray] =
    useState([])
  const [topRatedRestaurantFilterArray, setTopRatedeRestaurantFilterArray] =
    useState([])
  const [onScheduleRestaurantFilterArray, setOnScheduleRestaurantFilterArray] =
    useState([])

  const [newRestaurantFilterArray, setNewRestaurantFilterArray] = useState([])
  const [
    withHostingFeeRestaurantFilterArray,
    setWithHostingFeeRestaurantFilterArray,
  ] = useState([])
  const [discountedRestaurantFilterArray, setDiscountedRestaurantFilterArray] =
    useState([])
  const [featuredRestaurantFilterArray, setFeaturedRestaurantFilterArray] =
    useState([])

  const loadMainCategories = () => {
    setmaincategoriesLoading(true)
    Axios.get(`${K.baseUrl}users/maincategories`)
      .then((resp) => {
        if (resp.data.resultcode === 1) {
          setMaincategories(resp.data.categories)
          setmaincategoriesLoading(false)
        }
      })
      .catch((error) => {
        setmaincategoriesLoading(false)
      })
  }

  const restaurants = async () => {
    setisLoading(true)
    var resp
    try {
      resp = await Axios.get(`${K.baseUrl}users/restaurants`)
      setisLoading(false)
    } catch (error) {
      setisLoading(false)
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.indexOf('log in') > -1
      ) {
        props.logOut()
        return
      }
    }
    if (resp && resp.message && resp.message.indexOf('log in') > -1) {
      props.logOut()
      return
    }
    try {
      setAllRestaurants(resp.data.response ? resp.data.response : [])
    } catch (error) {
      setAllRestaurants([])
    }
  }

  useEffect(() => {
    restaurants()
    loadMainCategories()
  }, [])

  // user to compare distance ranges
  const inRangeBetween = (x, min, max) => x >= min && x <= max

  const setLocation = () => {
    props.changeLocation()
  }

  const handleFilterRestaurantByDistance = (min, max) => {
    setDistanceFilter({
      min: min,
      max: max,
    })
  }

  const filterResturants = () => {
    let _restaurant = []

    let _onlinerestaurant = []
    let _nearme5kmrestaurant = []
    let _topRatedrestaurant = []
    let _onSchedulerestaurant = []

    let _newrestaurant = []
    let _withhostingfeerestaurant = []
    let _discountedrestaurant = []
    let _featuredrestaurant = []

    setisLoading(true)

    var clat = statecoordinates ? statecoordinates.lat : undefined
    var clng = statecoordinates ? statecoordinates.lng : undefined

    allRestaurants.map((restaurant) => {
      if (
        (restaurantcategory === 0 ||
          restaurant.restaurant.main_category_id === restaurantcategory) &&
        restaurant.restaurant.open_status === 'open'
      ) {
        if (!diatery || restaurant.rtype === diatery) {
          if (
            sort === 'All' ||
            (sort === 'popular' &&
              parseFloat(restaurant.restaurant.rating) >= 4.5)
          ) {
            var rlat = restaurant.restaurant.latitude
            var rlng = restaurant.restaurant.longitude
            var dist = 0
            if (clat != undefined && clng != undefined) {
              var dist = service.getDistanceFromLatLonInKm(
                rlat,
                rlng,
                clat,
                clng,
              )
            }
            if (
              inRangeBetween(dist, distanceFilter.min, distanceFilter.max) ||
              dist === 0
            ) {
              _restaurant.push(restaurant)
              //online
              if (restaurant.opened === 1) {
                _onlinerestaurant.push(restaurant)
              }
              //nearme within 5km radius
              if (inRangeBetween(dist, 0, 5)) {
                _nearme5kmrestaurant.push(restaurant)
              }
              //top rated
              if (parseFloat(restaurant.restaurant.rating) >= 4.5) {
                _topRatedrestaurant.push(restaurant)
              }
              //onschedule
              if (restaurant.restaurant.Avataris_schedule_enabled === 1) {
                _onSchedulerestaurant.push(restaurant)
              }
              // newrestaurant
              if (restaurant.restaurant.is_new) {
                _newrestaurant.push(restaurant)
              }
              // withhostingfeerestaurant
              if (restaurant.restaurant.hosting_fee > 0) {
                _withhostingfeerestaurant.push(restaurant)
              }
              // discountedrestaurant
              if (restaurant.restaurant.discount > 0) {
                _discountedrestaurant.push(restaurant)
              }
              // featuredrestaurant
              if (restaurant.restaurant.is_featured > 0) {
                _featuredrestaurant.push(restaurant)
              }
            }
          }
        }
      }
    })

    setRestaurantFilterArray(_restaurant)

    setOnlineRestaurantFilterArray(_onlinerestaurant)
    setNearMe5kmRestaurantFilterArray(_nearme5kmrestaurant)
    setTopRatedeRestaurantFilterArray(_topRatedrestaurant)
    setOnScheduleRestaurantFilterArray(_onSchedulerestaurant)

    setNewRestaurantFilterArray(_newrestaurant)
    setWithHostingFeeRestaurantFilterArray(_withhostingfeerestaurant)
    setDiscountedRestaurantFilterArray(_discountedrestaurant)
    setFeaturedRestaurantFilterArray(_featuredrestaurant)

    setisLoading(false)

    // console.log(_onlinerestaurant);
    // console.log(_nearme5kmrestaurant);
    // console.log(_topRatedrestaurant);
    // console.log(_onSchedulerestaurant);
  }

  //restaurant type for fileter

  const [rtype, setRtype] = useState([])

  useEffect(() => {
    // let _rtype = [];
    // allRestaurants.map((item) => {
    //   _rtype.push(item.restaurant.rtype);
    // });
    // setRtype(_rtype);
  }, [allRestaurants])

  useEffect(() => {
    filterResturants()
  }, [sort, allRestaurants, distanceFilter, restaurantcategory, diatery])

  const onCategoriesFilterClicked = (maincategory) => {
    setrestaurantcategory(maincategory.id)
    localStorage.setItem('maincategory', maincategory.id)
  }

  const diataryCallBack = (str) => {
    setDiatery(str)
  }

  const [openModal, setOpenModal] = React.useState(false)
  const [mapMode, setMapMode] = React.useState(false)

  const handleFilterModalClickOpen = () => {
    setOpenModal(true)
  }

  const handleClose = () => {
    setOpenModal(false)
  }
  const [restaurantMeal, setRestaurantMeal] = React.useState([])
  const [resinfo, setResinfo] = React.useState({})
  const handleSetSelectedRestaurant = (res) => {
    setRestaurantMeal(res.meals)
    setResinfo(res)
  }

  const handleSetMapView = () => {
    setMapMode(!mapMode)
  }

  return (
    <div className={theme && theme == 'DARK' ? 'dark_theme' : 'light_theme'}>
      <div className={'main-wrapper inner--page'}>
        {mapMode ? (
          <div className="noscroll">
            <Box sx={{ flexGrow: 1 }} className="">
              <div className="mt-12 side overlay pl-1">
                {restaurantFilterArray
                  ? restaurantFilterArray.map((restaurantsingle, index) => (
                      <div key={index}>
                        <RestaurantComponent
                          key={index}
                          image={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.image}`}
                          banner={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.bannerimage}`}
                          retaurantName={restaurantsingle.restaurantname}
                          opened={restaurantsingle.opened}
                          open_status={restaurantsingle.restaurant.open_status}
                          restaurant={restaurantsingle.restaurant}
                          restaurantsingle={restaurantsingle}
                          setSelectedRestaurant={handleSetSelectedRestaurant}
                          mapView={mapMode}
                        />
                      </div>
                    ))
                  : ''}
              </div>
              <div className=".">
                <RestaurantMap
                  restaurantsArray={restaurantFilterArray}
                  setSelectedRestaurant={handleSetSelectedRestaurant}
                />
                <div className="flex">
                  <div className="product-overlay horizontal-scroll">
                    {restaurantMeal &&
                      restaurantMeal.map((meal, index) => (
                        <ProductCard
                          key={index}
                          mealObj={meal}
                          props={props}
                          restaurant={resinfo}
                        />
                      ))}
                  </div>
                </div>
              </div>
            </Box>
          </div>
        ) : (
          <section className="category-sec">
            <div style={{ padding: '1rem' }} className="row">
              <div className="d-sm-none col-xl-2  col-lg-3 d-lg-block overlay1">
                <Hidden xsDown>
                  <Filter
                    address={address}
                    coordinates={statecoordinates}
                    rtype={rtype}
                    diataryCallBack={diataryCallBack}
                    handleFilterRestaurantByDistance={
                      handleFilterRestaurantByDistance
                    }
                    setLocation={setLocation}
                    setSortFilter={(value) => {
                      setSortFilter(value)
                    }}
                  />
                </Hidden>
                <Dialog
                  open={openModal}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title"></DialogTitle>
                  <DialogContent>
                    <Filter
                      address={address}
                      coordinates={statecoordinates}
                      rtype={rtype}
                      diataryCallBack={diataryCallBack}
                      handleFilterRestaurantByDistance={
                        handleFilterRestaurantByDistance
                      }
                      setLocation={setLocation}
                      setSortFilter={(value) => {
                        setSortFilter(value)
                      }}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                  </DialogActions>
                </Dialog>
              </div>
              <div className="col-xl-10 col-lg-9 col-sm-12 col-xs-12 pl-5 pr-5">
                {/* <div className="row category-listing" onClick={handleSetMapView}> */}
                <div className="row category-listing">
                  {/* <div className="col-12 mb-4">
                    <h3 className='restaurantTitle'>{restaurantFilterArray.length === 0 ? "There are no restaurants." : ''}</h3>
                  </div> */}
                  <div className="col-12 mb-4">
                    <>
                      <Hidden mdDown>
                        <h3 className="restaurantTitle">
                          {' '}
                          <FilterAltIcon /> Filter
                        </h3>
                      </Hidden>
                      <Hidden mdUp>
                        <Fab
                          variant="extended"
                          onClick={handleFilterModalClickOpen}
                        >
                          <FilterAltIcon sx={{ ml: 1 }} />
                          Fillter
                        </Fab>
                      </Hidden>
                    </>
                  </div>
                  <Stack
                    direction="row"
                    spacing={1}
                    className="flex ml-2 mr-2 mb-3 horizontal-scroll"
                  >
                    {maincategoriesLoading ? (
                      <>
                        <CategoryLoader />
                        <CategoryLoader />
                        <CategoryLoader />
                        <CategoryLoader />
                        <CategoryLoader />
                        <CategoryLoader />
                      </>
                    ) : (
                      <Stack
                        direction="row"
                        spacing={1}
                        className="flex ml-2 mr-2 mb-3 horizontal-scroll"
                      >
                        <Chip
                          label={'All'}
                          variant="outlined"
                          onClick={() => {
                            setrestaurantcategory(0)
                            localStorage.setItem('maincategory', 0)
                          }}
                          style={
                            restaurantcategory === 0
                              ? { backgroundColor: '#42B749' }
                              : {}
                          }
                        />
                        {mainCategories.map((maincategory, index) => (
                          <div key={index}>
                            <Chip
                              avatar={
                                <Avatar
                                  alt={maincategory.description}
                                  src={
                                    `${K.imageBaseUlr}` +
                                    '/images_fd/' +
                                    maincategory.image
                                  }
                                />
                              }
                              label={maincategory.name}
                              variant="outlined"
                              onClick={() =>
                                onCategoriesFilterClicked(maincategory)
                              }
                              style={
                                restaurantcategory === maincategory.id
                                  ? { backgroundColor: '#42B749' }
                                  : {}
                              }
                            />
                          </div>
                        ))}
                      </Stack>
                    )}
                  </Stack>
                </div>

                <div className="row">
                  {onlineRestaurantFilterArray.length > 0 ? (
                    <h2 className="restaurantTitle pl-3">Online Restaurants</h2>
                  ) : (
                    ''
                  )}
                </div>
                <div className="container row">
                  {isLoading ? (
                    <>
                      <RestaurantLoader isLoading={isLoading} />
                    </>
                  ) : (
                    ''
                  )}
                  {onlineRestaurantFilterArray
                    ? onlineRestaurantFilterArray.map(
                        (restaurantsingle, index) => (
                          <div
                            key={index}
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              openRestaurant(restaurantsingle.restaurantid)
                            }
                          >
                            <RestaurantComponent
                              key={index}
                              image={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.image}`}
                              banner={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.bannerimage}`}
                              retaurantName={restaurantsingle.restaurantname}
                              opened={restaurantsingle.opened}
                              open_status={
                                restaurantsingle.restaurant.open_status
                              }
                              restaurant={restaurantsingle.restaurant}
                              restaurantsingle={restaurantsingle}
                            />
                          </div>
                        ),
                      )
                    : ''}
                </div>
                <div className="row">
                  {nearMe5kmRestaurantFilterArray.length > 0 ? (
                    <h2 className="restaurantTitle pl-3">
                      Restaurants near me
                    </h2>
                  ) : (
                    ''
                  )}
                </div>
                <div className="container row">
                  {isLoading ? (
                    <>
                      <RestaurantLoader isLoading={isLoading} />
                    </>
                  ) : (
                    ''
                  )}
                  {nearMe5kmRestaurantFilterArray
                    ? nearMe5kmRestaurantFilterArray.map(
                        (restaurantsingle, index) => (
                          <div
                            key={index}
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              openRestaurant(restaurantsingle.restaurantid)
                            }
                          >
                            <RestaurantComponent
                              key={index}
                              image={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.image}`}
                              banner={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.bannerimage}`}
                              retaurantName={restaurantsingle.restaurantname}
                              opened={restaurantsingle.opened}
                              open_status={
                                restaurantsingle.restaurant.open_status
                              }
                              restaurant={restaurantsingle.restaurant}
                              restaurantsingle={restaurantsingle}
                            />
                          </div>
                        ),
                      )
                    : ''}
                </div>
                <div className="row">
                  {topRatedRestaurantFilterArray.length > 0 ? (
                    <h2 className="restaurantTitle pl-3">
                      Top Rated Restaurants
                    </h2>
                  ) : (
                    ''
                  )}
                </div>
                <div className="container row">
                  {isLoading ? (
                    <>
                      <RestaurantLoader isLoading={isLoading} />
                    </>
                  ) : (
                    ''
                  )}
                  {topRatedRestaurantFilterArray
                    ? topRatedRestaurantFilterArray.map(
                        (restaurantsingle, index) => (
                          <div
                            key={index}
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              openRestaurant(restaurantsingle.restaurantid)
                            }
                          >
                            <RestaurantComponent
                              key={index}
                              image={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.image}`}
                              banner={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.bannerimage}`}
                              retaurantName={restaurantsingle.restaurantname}
                              opened={restaurantsingle.opened}
                              open_status={
                                restaurantsingle.restaurant.open_status
                              }
                              restaurant={restaurantsingle.restaurant}
                              restaurantsingle={restaurantsingle}
                            />
                          </div>
                        ),
                      )
                    : ''}
                </div>

                <div className="row">
                  {newRestaurantFilterArray.length > 0 ? (
                    <h2 className="restaurantTitle pl-3">New Restaurants</h2>
                  ) : (
                    ''
                  )}
                </div>
                <div className="container row">
                  {isLoading ? (
                    <>
                      <RestaurantLoader isLoading={isLoading} />
                    </>
                  ) : (
                    ''
                  )}
                  {newRestaurantFilterArray
                    ? newRestaurantFilterArray.map(
                        (restaurantsingle, index) => (
                          <div
                            key={index}
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              openRestaurant(restaurantsingle.restaurantid)
                            }
                          >
                            <RestaurantComponent
                              key={index}
                              image={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.image}`}
                              banner={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.bannerimage}`}
                              retaurantName={restaurantsingle.restaurantname}
                              opened={restaurantsingle.opened}
                              open_status={
                                restaurantsingle.restaurant.open_status
                              }
                              restaurant={restaurantsingle.restaurant}
                              restaurantsingle={restaurantsingle}
                            />
                          </div>
                        ),
                      )
                    : ''}
                </div>
                <div className="row">
                  {withHostingFeeRestaurantFilterArray.length > 0 ? (
                    <h2 className="restaurantTitle pl-3">
                      Restaurants with Hosting Fee
                    </h2>
                  ) : (
                    ''
                  )}
                </div>
                <div className="container row">
                  {isLoading ? (
                    <>
                      <RestaurantLoader isLoading={isLoading} />
                    </>
                  ) : (
                    ''
                  )}
                  {withHostingFeeRestaurantFilterArray
                    ? withHostingFeeRestaurantFilterArray.map(
                        (restaurantsingle, index) => (
                          <div
                            key={index}
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              openRestaurant(restaurantsingle.restaurantid)
                            }
                          >
                            <RestaurantComponent
                              key={index}
                              image={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.image}`}
                              banner={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.bannerimage}`}
                              retaurantName={restaurantsingle.restaurantname}
                              opened={restaurantsingle.opened}
                              open_status={
                                restaurantsingle.restaurant.open_status
                              }
                              restaurant={restaurantsingle.restaurant}
                              restaurantsingle={restaurantsingle}
                            />
                          </div>
                        ),
                      )
                    : ''}
                </div>
                <div className="row">
                  {discountedRestaurantFilterArray.length > 0 ? (
                    <h2 className="restaurantTitle pl-3">
                      Discounted Restaurants
                    </h2>
                  ) : (
                    ''
                  )}
                </div>
                <div className="container row">
                  {isLoading ? (
                    <>
                      <RestaurantLoader isLoading={isLoading} />
                    </>
                  ) : (
                    ''
                  )}
                  {discountedRestaurantFilterArray
                    ? discountedRestaurantFilterArray.map(
                        (restaurantsingle, index) => (
                          <div
                            key={index}
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              openRestaurant(restaurantsingle.restaurantid)
                            }
                          >
                            <RestaurantComponent
                              key={index}
                              image={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.image}`}
                              banner={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.bannerimage}`}
                              retaurantName={restaurantsingle.restaurantname}
                              opened={restaurantsingle.opened}
                              open_status={
                                restaurantsingle.restaurant.open_status
                              }
                              restaurant={restaurantsingle.restaurant}
                              restaurantsingle={restaurantsingle}
                            />
                          </div>
                        ),
                      )
                    : ''}
                </div>
                <div className="row">
                  {featuredRestaurantFilterArray.length > 0 ? (
                    <h2 className="restaurantTitle pl-3">
                      Featured Restaurants
                    </h2>
                  ) : (
                    ''
                  )}
                </div>
                <div className="container row">
                  {isLoading ? (
                    <>
                      <RestaurantLoader isLoading={isLoading} />
                    </>
                  ) : (
                    ''
                  )}
                  {featuredRestaurantFilterArray
                    ? featuredRestaurantFilterArray.map(
                        (restaurantsingle, index) => (
                          <div
                            key={index}
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              openRestaurant(restaurantsingle.restaurantid)
                            }
                          >
                            <RestaurantComponent
                              key={index}
                              image={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.image}`}
                              banner={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.bannerimage}`}
                              retaurantName={restaurantsingle.restaurantname}
                              opened={restaurantsingle.opened}
                              open_status={
                                restaurantsingle.restaurant.open_status
                              }
                              restaurant={restaurantsingle.restaurant}
                              restaurantsingle={restaurantsingle}
                            />
                          </div>
                        ),
                      )
                    : ''}
                </div>

                <div className="row">
                  {onScheduleRestaurantFilterArray.length > 0 ? (
                    <h2 className="restaurantTitle pl-3">
                      On Scheduled Restaurants
                    </h2>
                  ) : (
                    ''
                  )}
                </div>
                <div className="container row">
                  {isLoading ? (
                    <>
                      <RestaurantLoader isLoading={isLoading} />
                    </>
                  ) : (
                    ''
                  )}
                  {onScheduleRestaurantFilterArray
                    ? onScheduleRestaurantFilterArray.map(
                        (restaurantsingle, index) => (
                          <div
                            key={index}
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              openRestaurant(restaurantsingle.restaurantid)
                            }
                          >
                            <RestaurantComponent
                              key={index}
                              image={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.image}`}
                              banner={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.bannerimage}`}
                              retaurantName={restaurantsingle.restaurantname}
                              opened={restaurantsingle.opened}
                              open_status={
                                restaurantsingle.restaurant.open_status
                              }
                              restaurant={restaurantsingle.restaurant}
                              restaurantsingle={restaurantsingle}
                            />
                          </div>
                        ),
                      )
                    : ''}
                </div>
                <div className="row">
                  {restaurantFilterArray.length > 0 ? (
                    <h2 className="restaurantTitle pl-3">All Restaurants</h2>
                  ) : (
                    <h2 className="restaurantTitle pl-3">
                      No restaurants Available
                    </h2>
                  )}
                </div>
                <div className="container row">
                  {isLoading ? (
                    <>
                      <RestaurantLoader isLoading={isLoading} />
                    </>
                  ) : (
                    ''
                  )}
                  {restaurantFilterArray
                    ? restaurantFilterArray.map((restaurantsingle, index) => (
                        <div
                          key={index}
                          style={{ cursor: 'pointer' }}
                          onClick={() =>
                            openRestaurant(restaurantsingle.restaurantid)
                          }
                        >
                          <RestaurantComponent
                            key={index}
                            image={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.image}`}
                            banner={`${K.imageBaseUlr}img/${restaurantsingle.restaurant.bannerimage}`}
                            retaurantName={restaurantsingle.restaurantname}
                            opened={restaurantsingle.opened}
                            open_status={
                              restaurantsingle.restaurant.open_status
                            }
                            restaurant={restaurantsingle.restaurant}
                            restaurantsingle={restaurantsingle}
                          />
                        </div>
                      ))
                    : ''}
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    </div>
  )
}
export default Restaurants
